import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAnnotation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.33333 4.66665H12.6667M4.33333 7.99998H7.66667M8.5 14.6666L5.16667 11.3333H2.66667C2.22464 11.3333 1.80072 11.1577 1.48816 10.8452C1.17559 10.5326 1 10.1087 1 9.66665V2.99998C1 2.55795 1.17559 2.13403 1.48816 1.82147C1.80072 1.50891 2.22464 1.33331 2.66667 1.33331H14.3333C14.7754 1.33331 15.1993 1.50891 15.5118 1.82147C15.8244 2.13403 16 2.55795 16 2.99998V9.66665C16 10.1087 15.8244 10.5326 15.5118 10.8452C15.1993 11.1577 14.7754 11.3333 14.3333 11.3333H11.8333L8.5 14.6666Z",
		stroke: "currentColor",
		strokeWidth: 1.4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAnnotation;
